export const DAY_TIME_SLOT_TYPE = "daily"
export const HOURS_TIME_SLOT_TYPE = "hourly"
export const TOTAL_HOUR_INPUTS_NUMBER = 10
export const MIN_HOUR_INPUTS_NUMBER = 3
